import { propertyUseQuery, propertyQueryFn, propertyAlgoliaQueryFn } from 'Services/reactQuery'
import errorLogger from 'Root/errorLogger'
import { ALGOLIA_PREFIX } from 'Config/config'
import { classTypeToAreaParam } from 'Defaults/map'


export const useFetchSiteMap = ({ id, areaType, pageParams }) => {
  let data = null
  if(areaType && id) {
    data = {
      area_type: areaType,
      area_id: id,
    }
  }
  const page = pageParams?.page

  return (
    propertyUseQuery(
      ['siteMap', areaType, id, page],
      propertyQueryFn({
        url: `sitemap${data ? `/area?area_type=${areaType}&area_id=${id}${page ? `&page=${page}` : ''}` : ''}`,
      }),
      { enabled: Boolean(areaType && id) })
  )
}


export const fetchRecentListings = async ({ areaType, areaId }) => {
  if((!areaType)) return Promise.resolve({ response: null })


  const now = new Date()
  const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const startOfDayUnix = startOfDay / 1000

  let filters = ['(status:"Active")']

  filters.push(`(${classTypeToAreaParam[areaType]}=${areaId})`)
  filters.push(`(entry_date_unix>=${startOfDayUnix})`)
  filters.push('(advertise_permission=1)')

  filters = filters.length > 1 ? filters.join(' AND ') : filters
  let result = {
    nbHits: 0,
    hits: [],
  }
  try {
    // eslint-disable-next-line
    result = await propertyAlgoliaQueryFn({
      query: [
        {
          indexName: ALGOLIA_PREFIX + 'search_listings',
          params: {
            filters,
            hitsPerPage: 1000,
            attributesToRetrieve: [
              'title', 'subtitle', 'bed_type', 'bedrooms', 'bathrooms', 'advertise_permission',
              'url', 'entry_date', 'asking_price', 'locality_name', 'province_name',
            ],
          },

        },
      ],
    })
  } catch(e) {
    errorLogger('algoliaListingsRecent', e)
  }
  return Promise.resolve(result && result.nbHits ? { response: { data: { data: result.hits } } } : null)
}

export const useFetchRecentListings = ({ areaType, areaId }) => (
  propertyUseQuery(
    ['recentActive', areaType, areaId],
    () => fetchRecentListings({ areaType, areaId }),
    { enabled: Boolean(areaType && areaId) })
)
